<template>
  <div id="devCenterIndex" class="devCenterIndex">
    <!-- step-header -->
    <div class="step-header">
      <div class="headerImg-wrapper">
        <img class="headerImg" :src="`${$baseUrl}dataMock/devCenter/step-header.png`">
      </div>
      <div class="step-header-title">
        <div class="headerImg-wrapper leftTop">
          <img class="headerImg" :src="`${$baseUrl}dataMock/devCenter/step-header-airplane.png`">
        </div>
        <span class="header-title-content">仅需4步！快速搭建属于自己的BIM应用</span>
      </div>
    </div>
    <!-- <div class="searchBGImg" :style="{backgroundImage: `url(${$baseUrl}dataMock/devCenter/DCbanner1.png)` }">
      <el-input placeholder="请输入搜索内容" v-model="searchInput" class="searchInput">
        <el-button slot="append" icon="el-icon-search">搜索</el-button>
      </el-input>
    </div> -->
    <!-- 第一步 -->
    <div class="step-one step-grid">
      <div class="step-container">
          <div class="step-contont">
            <span class="step-contont-count">1.</span>
            <span class="step-contont-text">注册用户</span>
          </div>
          <button class="step-btn" @click="userRegistery">立即注册</button>
      </div>
      <div class="headerImg-wrapper step-image">
        <img class="headerImg" :src="`${$baseUrl}dataMock/devCenter/step-one.png`">
      </div>
    </div>
    <!-- 第二步 -->
    <div class="step-two step-grid">
      <div class="step-container">
          <div class="step-contont">
            <span class="step-contont-count">2.</span>
            <span class="step-contont-text" >创建应用</span>
          </div>
          <button class="step-btn" style="width: 200px" @click="creatApp">创建我的应用</button>
      </div>
      <div class="headerImg-wrapper step-image">
        <img class="headerImg" :src="`${$baseUrl}dataMock/devCenter/step-two.png`">
      </div>
    </div>
    <!-- 第三步 -->
    <div class="step-three step-grid">
      <div class="step-container">
          <div class="step-contont">
            <span class="step-contont-count">3.</span>
            <span class="step-contont-text" >上传转换模型</span>
          </div>
          <button class="step-btn" @click="fileMng">模型体验</button>
          <span class="step-contont-detail">70+种文件格式在线浏览：</span>
          <span class="step-contont-subDetail">RVT IFC NWD DGN DWG Pdms FBX 3DS SKP Pbims ...
            <el-popover
              placement="bottom"
              title="支持格式"
              width="500"
              trigger="hover">
                <div><span style="font-weight: bold">BIM软件模型：</span>Pbims、RVT、RFA、RTE、DGN、ifc、STEP、XDB、Pmodel、3dm、NWC、NWD…</div>
                <div><span style="font-weight: bold">三维模型：</span>DWF、DWFX、SKP、OBJ、DAE、3DS、FBX、STL、SLDPRT、RVM、JT、SAT、WRL、XGL、X3D、PRJ、IPT…</div>
                <div><span style="font-weight: bold">图纸：</span>DWG、DXF…</div>
                <div><span style="font-weight: bold">图片：</span>Jpg、peg、Bmp、png、Gif、tiff…</div>
                <div><span style="font-weight: bold">文档：</span>Office（97-16）、PDF、MPP、XML、html、Txt、xps、Oxps…</div>
                <el-button class="step-contont-moreDetail" slot="reference">!
                </el-button>
            </el-popover>
          </span>
      </div>
      <div class="headerImg-wrapper step-image">
        <img class="headerImg" :src="`${$baseUrl}dataMock/devCenter/step-three.png`">
      </div>
    </div>
    <!-- 第四步 -->
    <div class="step-four step-grid">
      <div class="step-container">
          <div class="step-contont">
            <span class="step-contont-count">4.</span>
            <span class="step-contont-text" @click="downDemoCode">集成代码样例</span>
          </div>
          <button class="step-btn" style="width: 240px" @click="downDemoCode">代码样例下载</button>
      </div>
      <div class="headerImg-wrapper step-image">
        <img class="headerImg" :src="`${$baseUrl}dataMock/devCenter/step-four.png`">
      </div>
    </div>
    <!-- step-bottom -->
    <div class="step-bottom">
      <div class="headerImg-wrapper">
        <img class="headerImg" :src="`${$baseUrl}dataMock/devCenter/step-loginConsole.png`">
      </div>
      <button @click="fileMng">登录控制台</button>
    </div>
  </div>
</template>

<script>

export default {
    name: 'devCenterIndex',
    components: {
    },
    data() {
        return {
            searchInput: '',
            centerData: [],
            headerTile: '开发者中心',
            linkBack: {
                name: '构力云平台',
                path: '/',
            },
            activeTab: [0, 1],
        };
    },
    methods: {
        userRegistery() {
            this.$router.push('/login');
        },
        creatApp() {
            this.$router.push('/devcenter/console/myapp');
        },
        fileMng() {
            this.$router.push('/devcenter/console/fileManagement');
        },
        downDemoCode() {
            window.open('https://gitee.com/pkpm/cloud-platform-workshop', '_blank');
        },

    },
    mounted() {

    },
};
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  @import '~common/stylus/mixin'
  #devCenterIndex
    height auto
    background: linear-gradient(to bottom, $getStart-startColor 0%, $getStart-endColor 100%)
    .headerImg-wrapper
      .headerImg
        width: auto
        height: auto
        max-width: 100%
        max-height: 100%
    .step-header
      height 575px
      dom_center()
      flex-direction: column
      .headerImg-wrapper.leftTop
        position: relative
        top: 26px
        left: -26px
      .header-title-content
        display block
        background: rgba(255,255,255,0.10);
        border: 1px solid rgba(255,255,255,0.50);
        color: $font-white;
        font-weight bold
    .step-container
      display flex
      flex-direction column
      justify-content: space-evenly
      .step-contont
      .step-contont-subDetail
        .step-contont-moreDetail
          font-size: 20px
          padding: 1px 8px
          border-radius: 50%
          background: transparent
          color: $font-white
      .step-btn
        width: 160px
        height: 50px
        background: rgba(255,255,255,0.20)
        border: 1px solid rgba(255,255,255,0.60)
        border-radius: 25px
        font-size: 20px;
        font-weight bold
        line-height: 20px
        outline: none
        &:hover
          background: #FFB12C
          border: 1px solid #FFB12C
    .headerImg-wrapper.step-image
      width 25%
      dom_center()
    .step-grid
      width 100%
      display flex
      justify-content: flex-start
    .step-one
      background: $getStart-shadeColor;
    .step-three
      background: $getStart-shadeColor;
    .step-bottom
      height 80px
      background-color $getStart-bottomColor
      dom_center()
      font-size 24px
      line-height 24px
      button
        border: 0px
        outline: none
        background-color transparent
        margin-left: 36px
        padding-bottom: 6px
        cursor pointer
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/getStarted/getStartedIndex.vue